import React, { useState, useEffect } from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
import ViewImage from "../Screen/ViewImage"
import moment from "moment"
import AccordianDataMultiple from "./AccordianDataMultiple"

const AccordianData = props => {
  const {
    item,
    sethandleAccordion,
    handleAccordion,
    keyId,
    setphotoIndex,
    setisGallery,
    keyIndex,
    MultipleDate,
  } = props

  const [multipleScreenDate, setmultipleScreenDate] = useState([])
  const [multipleScreenKeyChild, setmultipleScreenKeyChild] = useState(false)
  
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  useEffect(() => {
    const groupedData = (item[0]?.screenLogs || []).reduce((acc, data) => {
      // Format the capturetime to YYYY-MM-DD
      const formattedDate = moment(data.capturetime).format("YYYY-MM-DD")
      // Add the data to the corresponding group based on the formatted date
      if (!acc[formattedDate]) {
        acc[formattedDate] = []
      }
      acc[formattedDate].push(data)
      return acc
    }, {})
    setmultipleScreenDate(groupedData)
  }, [item])

  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyIndex}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion !== keyIndex,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordion(keyIndex)}
                style={{ cursor: "pointer" }}
              >
                {keyId}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion === keyIndex}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  <div
                    className="selectAllBody modal-body"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    {MultipleDate && (
                      <>
                        <>
                          {Object.entries(multipleScreenDate).map(
                            ([key, value], index) => (
                              <div key={index}>
                                <AccordianDataMultiple
                                  keyIndex={index} // Use date for the key of AccordianData
                                  item={value} // Pass the data array directly
                                  sethandleAccordion1={
                                    setmultipleScreenKeyChild
                                  }
                                  handleAccordion1={multipleScreenKeyChild}
                                  keyId={key}
                                  setphotoIndex={setphotoIndex}
                                  setisGallery={setisGallery}
                                />
                              </div>
                            )
                          )}
                        </>
                      </>
                    )}
                    {!MultipleDate && (
                      <>
                        <ViewImage
                          item={item}
                          setphotoIndex={setphotoIndex}
                          setisGallery={setisGallery}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}

export default AccordianData
